export enum FlexTableSize {
  Limited = "Limited",
  Full = "Full",
}

export enum FlexTableType {
  Card = "Card",
  Table = "Table",
}
